"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Units = void 0;
var Units;
(function (Units) {
    Units.EMPTY = {
        get megacredits() {
            return 0;
        },
        get steel() {
            return 0;
        },
        get titanium() {
            return 0;
        },
        get plants() {
            return 0;
        },
        get energy() {
            return 0;
        },
        get heat() {
            return 0;
        },
    };
    function of(partialUnits) {
        return {
            megacredits: partialUnits.megacredits === undefined ? 0 : partialUnits.megacredits,
            steel: partialUnits.steel === undefined ? 0 : partialUnits.steel,
            titanium: partialUnits.titanium === undefined ? 0 : partialUnits.titanium,
            plants: partialUnits.plants === undefined ? 0 : partialUnits.plants,
            energy: partialUnits.energy === undefined ? 0 : partialUnits.energy,
            heat: partialUnits.heat === undefined ? 0 : partialUnits.heat,
        };
    }
    Units.of = of;
    function negative(units) {
        return {
            megacredits: -units.megacredits,
            steel: -units.steel,
            titanium: -units.titanium,
            plants: -units.plants,
            energy: -units.energy,
            heat: -units.heat,
        };
    }
    Units.negative = negative;
    function adjustUnits(purse, delta) {
        return {
            megacredits: purse.megacredits + (delta.megacredits || 0),
            steel: purse.steel + (delta.steel || 0),
            titanium: purse.titanium + (delta.titanium || 0),
            plants: purse.plants + (delta.plants || 0),
            energy: purse.energy + (delta.energy || 0),
            heat: purse.heat + (delta.heat || 0),
        };
    }
    Units.adjustUnits = adjustUnits;
    function maybeAdjustReservedMegacredits(player, purse, howToAffordReds) {
        let newReservedMegacredits = (purse.megacredits || 0) - Math.max(player.megaCredits - (howToAffordReds.mustSpendAtMost || 0), 0);
        if (howToAffordReds.bonusMCFromPlay !== undefined) {
            newReservedMegacredits -= howToAffordReds.bonusMCFromPlay;
        }
        newReservedMegacredits = Math.max(newReservedMegacredits, 0);
        return {
            megacredits: newReservedMegacredits,
            steel: purse.steel,
            titanium: purse.titanium,
            plants: purse.plants,
            energy: purse.energy,
            heat: purse.heat,
        };
    }
    Units.maybeAdjustReservedMegacredits = maybeAdjustReservedMegacredits;
})(Units = exports.Units || (exports.Units = {}));
//# sourceMappingURL=Units.js.map